// ISO 3166-1 alpha-2 country codes with country names and flags
export interface Country {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  flag: string; // Emoji flag
}

export const COUNTRIES: Country[] = [
  // Mercati principali, in cima perché sono i più scelti
  { code: 'IT', name: 'Italia', flag: '🇮🇹' },
  { code: 'FR', name: 'Francia', flag: '🇫🇷' },
  { code: 'ES', name: 'Spagna', flag: '🇪🇸' },
  { code: 'DE', name: 'Germania', flag: '🇩🇪' },
  { code: 'GB', name: 'Regno Unito', flag: '🇬🇧' },
  { code: 'US', name: 'Stati Uniti', flag: '🇺🇸' },
  { code: 'CH', name: 'Svizzera', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹' },
  { code: 'PT', name: 'Portogallo', flag: '🇵🇹' },
  { code: 'GR', name: 'Grecia', flag: '🇬🇷' },
  { code: 'NL', name: 'Paesi Bassi', flag: '🇳🇱' },
  { code: 'BE', name: 'Belgio', flag: '🇧🇪' },
  { code: 'SE', name: 'Svezia', flag: '🇸🇪' },
  { code: 'NO', name: 'Norvegia', flag: '🇳🇴' },
  { code: 'DK', name: 'Danimarca', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', flag: '🇫🇮' },
  { code: 'IS', name: 'Islanda', flag: '🇮🇸' },
  { code: 'IE', name: 'Irlanda', flag: '🇮🇪' },
  { code: 'PL', name: 'Polonia', flag: '🇵🇱' },
  { code: 'CZ', name: 'Repubblica Ceca', flag: '🇨🇿' },
  { code: 'HU', name: 'Ungheria', flag: '🇭🇺' },
  { code: 'HR', name: 'Croazia', flag: '🇭🇷' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
  { code: 'TR', name: 'Turchia', flag: '🇹🇷' },
  { code: 'EG', name: 'Egitto', flag: '🇪🇬' },
  { code: 'MA', name: 'Marocco', flag: '🇲🇦' },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
  { code: 'ZA', name: 'Sudafrica', flag: '🇿🇦' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
  { code: 'AE', name: 'Emirati Arabi Uniti', flag: '🇦🇪' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲' },
  { code: 'IL', name: 'Israele', flag: '🇮🇱' },
  { code: 'JO', name: 'Giordania', flag: '🇯🇴' },
  { code: 'JP', name: 'Giappone', flag: '🇯🇵' },
  { code: 'CN', name: 'Cina', flag: '🇨🇳' },
  { code: 'TH', name: 'Thailandia', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'PH', name: 'Filippine', flag: '🇵🇭' },
  { code: 'KR', name: 'Corea del Sud', flag: '🇰🇷' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'MV', name: 'Maldive', flag: '🇲🇻' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nuova Zelanda', flag: '🇳🇿' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'MX', name: 'Messico', flag: '🇲🇽' },
  { code: 'BR', name: 'Brasile', flag: '🇧🇷' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', name: 'Cile', flag: '🇨🇱' },
  { code: 'PE', name: 'Perù', flag: '🇵🇪' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
  { code: 'DO', name: 'Repubblica Dominicana', flag: '🇩🇴' },
  { code: 'JM', name: 'Giamaica', flag: '🇯🇲' },

  // Resto dei paesi ISO 3166-1 alpha-2, in ordine alfabetico
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿' },
  { code: 'AD', name: 'Andorra', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴' },
  { code: 'AI', name: 'Anguilla', flag: '🇦🇮' },
  { code: 'AG', name: 'Antigua e Barbuda', flag: '🇦🇬' },
  { code: 'SA', name: 'Arabia Saudita', flag: '🇸🇦' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲' },
  { code: 'AW', name: 'Aruba', flag: '🇦🇼' },
  { code: 'AZ', name: 'Azerbaigian', flag: '🇦🇿' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸' },
  { code: 'BH', name: 'Bahrein', flag: '🇧🇭' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯' },
  { code: 'DY', name: 'Benin', flag: '🇩🇾' },
  { code: 'BM', name: 'Bermuda', flag: '🇧🇲' },
  { code: 'BT', name: 'Bhutan', flag: '🇧🇹' },
  { code: 'BY', name: 'Bielorussia', flag: '🇧🇾' },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia ed Erzegovina', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'HV', name: 'Burkina Faso', flag: '🇭🇻' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮' },
  { code: 'KH', name: 'Cambogia', flag: '🇰🇭' },
  { code: 'CM', name: 'Camerun', flag: '🇨🇲' },
  { code: 'CV', name: 'Capo Verde', flag: '🇨🇻' },
  { code: 'BQ', name: 'Caraibi Olandesi', flag: '🇧🇶' },
  { code: 'TD', name: 'Ciad', flag: '🇹🇩' },
  { code: 'CY', name: 'Cipro', flag: '🇨🇾' },
  { code: 'VA', name: 'Città del Vaticano', flag: '🇻🇦' },
  { code: 'KM', name: 'Comore', flag: '🇰🇲' },
  { code: 'CD', name: 'Congo - Kinshasa', flag: '🇨🇩' },
  { code: 'ZR', name: 'Congo - Kinshasa', flag: '🇿🇷' },
  { code: 'CG', name: 'Congo-Brazzaville', flag: '🇨🇬' },
  { code: 'KP', name: 'Corea del Nord', flag: '🇰🇵' },
  { code: 'CI', name: 'Costa d’Avorio', flag: '🇨🇮' },
  { code: 'CW', name: 'Curaçao', flag: '🇨🇼' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲' },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
  { code: 'ER', name: 'Eritrea', flag: '🇪🇷' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿' },
  { code: 'ET', name: 'Etiopia', flag: '🇪🇹' },
  { code: 'FJ', name: 'Figi', flag: '🇫🇯' },
  { code: 'FX', name: 'Francia', flag: '🇫🇽' },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦' },
  { code: 'GM', name: 'Gambia', flag: '🇬🇲' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪' },
  { code: 'DD', name: 'Germania', flag: '🇩🇩' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
  { code: 'GI', name: 'Gibilterra', flag: '🇬🇮' },
  { code: 'DJ', name: 'Gibuti', flag: '🇩🇯' },
  { code: 'GD', name: 'Grenada', flag: '🇬🇩' },
  { code: 'GL', name: 'Groenlandia', flag: '🇬🇱' },
  { code: 'GP', name: 'Guadalupa', flag: '🇬🇵' },
  { code: 'GU', name: 'Guam', flag: '🇬🇺' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
  { code: 'GG', name: 'Guernsey', flag: '🇬🇬' },
  { code: 'GN', name: 'Guinea', flag: '🇬🇳' },
  { code: 'GQ', name: 'Guinea Equatoriale', flag: '🇬🇶' },
  { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾' },
  { code: 'GF', name: 'Guyana Francese', flag: '🇬🇫' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶' },
  { code: 'CX', name: 'Isola Christmas', flag: '🇨🇽' },
  { code: 'IM', name: 'Isola di Man', flag: '🇮🇲' },
  { code: 'NF', name: 'Isola Norfolk', flag: '🇳🇫' },
  { code: 'AX', name: 'Isole Åland', flag: '🇦🇽' },
  { code: 'KY', name: 'Isole Cayman', flag: '🇰🇾' },
  { code: 'CC', name: 'Isole Cocos (Keeling)', flag: '🇨🇨' },
  { code: 'CK', name: 'Isole Cook', flag: '🇨🇰' },
  { code: 'FO', name: 'Isole Fær Øer', flag: '🇫🇴' },
  { code: 'FK', name: 'Isole Falkland', flag: '🇫🇰' },
  { code: 'MP', name: 'Isole Marianne Settentrionali', flag: '🇲🇵' },
  { code: 'MH', name: 'Isole Marshall', flag: '🇲🇭' },
  { code: 'PN', name: 'Isole Pitcairn', flag: '🇵🇳' },
  { code: 'SB', name: 'Isole Salomone', flag: '🇸🇧' },
  { code: 'TC', name: 'Isole Turks e Caicos', flag: '🇹🇨' },
  { code: 'VI', name: 'Isole Vergini Americane', flag: '🇻🇮' },
  { code: 'VG', name: 'Isole Vergini Britanniche', flag: '🇻🇬' },
  { code: 'JE', name: 'Jersey', flag: '🇯🇪' },
  { code: 'KZ', name: 'Kazakistan', flag: '🇰🇿' },
  { code: 'KG', name: 'Kirghizistan', flag: '🇰🇬' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮' },
  { code: 'XK', name: 'Kosovo', flag: '🇽🇰' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸' },
  { code: 'LV', name: 'Lettonia', flag: '🇱🇻' },
  { code: 'LB', name: 'Libano', flag: '🇱🇧' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷' },
  { code: 'LY', name: 'Libia', flag: '🇱🇾' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'LT', name: 'Lituania', flag: '🇱🇹' },
  { code: 'LU', name: 'Lussemburgo', flag: '🇱🇺' },
  { code: 'MK', name: 'Macedonia del Nord', flag: '🇲🇰' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹' },
  { code: 'MQ', name: 'Martinica', flag: '🇲🇶' },
  { code: 'MR', name: 'Mauritania', flag: '🇲🇷' },
  { code: 'MU', name: 'Mauritius', flag: '🇲🇺' },
  { code: 'YT', name: 'Mayotte', flag: '🇾🇹' },
  { code: 'FM', name: 'Micronesia', flag: '🇫🇲' },
  { code: 'MD', name: 'Moldavia', flag: '🇲🇩' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨' },
  { code: 'MN', name: 'Mongolia', flag: '🇲🇳' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
  { code: 'MS', name: 'Montserrat', flag: '🇲🇸' },
  { code: 'MZ', name: 'Mozambico', flag: '🇲🇿' },
  { code: 'BU', name: 'Myanmar (Birmania)', flag: '🇧🇺' },
  { code: 'MM', name: 'Myanmar (Birmania)', flag: '🇲🇲' },
  { code: 'NA', name: 'Namibia', flag: '🇳🇦' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
  { code: 'NU', name: 'Niue', flag: '🇳🇺' },
  { code: 'NC', name: 'Nuova Caledonia', flag: '🇳🇨' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦' },
  { code: 'PG', name: 'Papua Nuova Guinea', flag: '🇵🇬' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
  { code: 'PF', name: 'Polinesia Francese', flag: '🇵🇫' },
  { code: 'PR', name: 'Portorico', flag: '🇵🇷' },
  { code: 'HK', name: 'RAS di Hong Kong', flag: '🇭🇰' },
  { code: 'MO', name: 'RAS di Macao', flag: '🇲🇴' },
  { code: 'ZZ', name: 'Regione sconosciuta', flag: '🇿🇿' },
  { code: 'UK', name: 'Regno Unito', flag: '🇺🇰' },
  { code: 'CF', name: 'Repubblica Centrafricana', flag: '🇨🇫' },
  { code: 'RE', name: 'Riunione', flag: '🇷🇪' },
  { code: 'RW', name: 'Ruanda', flag: '🇷🇼' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺' },
  { code: 'SU', name: 'Russia', flag: '🇸🇺' },
  { code: 'EH', name: 'Sahara Occidentale', flag: '🇪🇭' },
  { code: 'KN', name: 'Saint Kitts e Nevis', flag: '🇰🇳' },
  { code: 'LC', name: 'Saint Lucia', flag: '🇱🇨' },
  { code: 'MF', name: 'Saint Martin', flag: '🇲🇫' },
  { code: 'VC', name: 'Saint Vincent e Grenadine', flag: '🇻🇨' },
  { code: 'BL', name: 'Saint-Barthélemy', flag: '🇧🇱' },
  { code: 'PM', name: 'Saint-Pierre e Miquelon', flag: '🇵🇲' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸' },
  { code: 'AS', name: 'Samoa Americane', flag: '🇦🇸' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲' },
  { code: 'SH', name: 'Sant’Elena', flag: '🇸🇭' },
  { code: 'ST', name: 'São Tomé e Príncipe', flag: '🇸🇹' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
  { code: 'CS', name: 'Serbia', flag: '🇨🇸' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸' },
  { code: 'YU', name: 'Serbia', flag: '🇾🇺' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱' },
  { code: 'SX', name: 'Sint Maarten', flag: '🇸🇽' },
  { code: 'SY', name: 'Siria', flag: '🇸🇾' },
  { code: 'SK', name: 'Slovacchia', flag: '🇸🇰' },
  { code: 'SO', name: 'Somalia', flag: '🇸🇴' },
  { code: 'SS', name: 'Sud Sudan', flag: '🇸🇸' },
  { code: 'SD', name: 'Sudan', flag: '🇸🇩' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷' },
  { code: 'SJ', name: 'Svalbard e Jan Mayen', flag: '🇸🇯' },
  { code: 'TJ', name: 'Tagikistan', flag: '🇹🇯' },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼' },
  { code: 'TF', name: 'Terre Australi Francesi', flag: '🇹🇫' },
  { code: 'PS', name: 'Territori Palestinesi', flag: '🇵🇸' },
  { code: 'IO', name: 'Territorio Britannico dell’Oceano Indiano', flag: '🇮🇴' },
  { code: 'TL', name: 'Timor Est', flag: '🇹🇱' },
  { code: 'TP', name: 'Timor Est', flag: '🇹🇵' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬' },
  { code: 'TK', name: 'Tokelau', flag: '🇹🇰' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad e Tobago', flag: '🇹🇹' },
  { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻' },
  { code: 'UA', name: 'Ucraina', flag: '🇺🇦' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿' },
  { code: 'NH', name: 'Vanuatu', flag: '🇳🇭' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
  { code: 'VD', name: 'Vietnam', flag: '🇻🇩' },
  { code: 'WF', name: 'Wallis e Futuna', flag: '🇼🇫' },
  { code: 'YD', name: 'Yemen', flag: '🇾🇩' },
  { code: 'YE', name: 'Yemen', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', flag: '🇿🇲' },
  { code: 'RH', name: 'Zimbabwe', flag: '🇷🇭' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼' },
];

/**
 * Get country by ISO code
 */
export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(c => c.code === code);
};

/**
 * Get multiple countries by ISO codes
 */
export const getCountriesByCodes = (codes: string[]): Country[] => {
  return codes.map(code => getCountryByCode(code)).filter(Boolean) as Country[];
};

/**
 * Search countries by name (case-insensitive)
 */
export const searchCountries = (query: string): Country[] => {
  const lowerQuery = query.toLowerCase();
  return COUNTRIES.filter(c => c.name.toLowerCase().includes(lowerQuery));
};
